import React from 'react';
import { useData } from '../../contexts/DataContext';
import { Loader2, Key, Power, RotateCcw, PowerOff, Terminal, User, Server } from 'lucide-react';
import moment from 'moment-timezone';

const getIconForAction = (actionType: string) => {
    if (actionType.includes('login')) return <Key className="w-5 h-5 text-green-500" />;
    if (actionType.includes('start')) return <Power className="w-5 h-5 text-blue-500" />;
    if (actionType.includes('restart')) return <RotateCcw className="w-5 h-5 text-yellow-500" />;
    if (actionType.includes('stop')) return <PowerOff className="w-5 h-5 text-red-500" />;
    return <Terminal className="w-5 h-5 text-gray-500" />;
};

const formatActionText = (action: string) => {
    const text = action.replace('server_', '').replace('_', ' ');
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const ActivityLogs: React.FC = () => {
    const { logs, loading } = useData();

    if (loading) {
        return (
            <div className="flex justify-center items-center p-8">
                <Loader2 className="animate-spin h-8 w-8 text-blue-500" />
            </div>
        );
    }

    return (
        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Logs de Actividad</h2>
            <div className="space-y-4">
                {logs.length > 0 ? (
                    logs.map(log => (
                        <div key={log.id} className="border-b border-gray-100 pb-4 mb-4 flex items-start space-x-4">
                            <div className="mt-1 bg-gray-100 rounded-full p-2">
                                {getIconForAction(log.actionType)}
                            </div>
                            <div className="flex-1">
                                <p className="font-semibold text-gray-800">
                                    <User className="inline-block w-4 h-4 mr-1 relative -top-px" />
                                    {log.clientName}
                                    <span className="text-gray-500 font-normal ml-2">({log.ipAddress})</span>
                                </p>
                                <p className="text-sm text-gray-600">
                                    <span className="font-medium">{formatActionText(log.actionType)}</span>
                                    {log.targetName && (
                                        <>
                                            <span className="mx-2 text-gray-300">|</span>
                                            <Server className="inline-block w-4 h-4 mr-1 relative -top-px" />
                                            {log.targetName}
                                        </>
                                    )}
                                </p>
                                {log.details && <p className="text-sm text-gray-500 mt-2 bg-gray-50 p-3 rounded-md border">{log.details}</p>}
                            </div>
                            <div className="text-right text-xs text-gray-400 whitespace-nowrap">
                                <p>{moment(log.timestamp).tz('Europe/Madrid').format('DD/MM/YYYY')}</p>
                                <p>{moment(log.timestamp).tz('Europe/Madrid').format('HH:mm:ss')}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-gray-500 py-8">No hay registros de actividad.</p>
                )}
            </div>
        </div>
    );
};
